// Fields the search inputs and the last executed search have in common.
const SHARED_INPUT_FIELDS = [
  "trailerType",
  "pickup",
  "pickupQuery",
  "delivery",
  "deliveryQuery",
  "pickupDate",
  "pickupDateEnd",
  "deliveryDate",
  "deliveryDateEnd",
  "pickupRadius",
  "deliveryRadius",
  "referenceId",
];

// Input values for the search that produced the page currently on screen.
// Used to restore the inputs when a previewed tab switch is cancelled.
export const inputsFromCurrentSearch = (currentSearch) =>
  SHARED_INPUT_FIELDS.reduce((inputs, field) => {
    inputs[field] = currentSearch?.[field] ?? null;
    return inputs;
  }, {});
